import {h, Component} from 'preact';
import Icon from '@components/common/Icon';
import tw from '@root/tailwind.config';

const QTY_LABEL = upi.i18n.getTextFromKey( 'abbr-quantity', 'Qty' );
const btnClass = 'justify-center flex-0 p-3 bg-grey-darker text-white rounded-sm focus:outline hover:bg-grey-dark t-bg-color t-duration-short';

class QtyToggle extends Component {
    constructor( props ) {
        super( props );

        this.onChange = this.onChange.bind( this );
        this.decrement = this.decrement.bind( this );
        this.increment = this.increment.bind( this );

        this.state = {
            value: props.value || 1
        };
    }

    increment() {
        const value = parseInt( this.state.value + 1, 10 );
        this.setMinMaxValue( value );
    }

    decrement() {
        const value = parseInt( this.state.value - 1, 10 );
        this.setMinMaxValue( value );
    }

    onChange( {currentTarget} ) {
        this.setMinMaxValue( currentTarget.value );
    }

    setMinMaxValue( value ) {
        const {min, max, onChange} = this.props;
        value = Math.min( Math.max( value, min ), max );
        this.setState( {value}, () => Boolean( onChange ) && onChange( value ) );
    }

    render( props ) {
        const fieldProps = {
            id: props.id,
            name: props.id,
            min: props.min,
            max: props.max
        };

        return (
            <fieldset className={`flex flex-0 justify-center w-32 ${props.className}`}>
                <label for="skuQty" className="text-xs uppercase self-center w-full text-center">{QTY_LABEL}</label>
                <div className="flex">
                    <button className={`${btnClass} rounded-r-none`} onClick={this.decrement}>
                        <Icon.ui name="minus" wrapperClassName="block h-3"/>
                    </button>
                    <input value={this.state.value}
                           className="text-center"
                           ref={ref => this.input = ref}
                           style={{
                               margin: 0,
                               borderRadius: 0,
                               borderWidth: '1px 0',
                               borderColor: tw.colors['grey-darker']
                           }}
                           onChange={this.onChange}
                           type="number" {...fieldProps} />
                    <button className={`${btnClass} rounded-l-none`} onClick={this.increment}>
                        <Icon.ui name="plus" wrapperClassName="block h-3"/>
                    </button>
                </div>
            </fieldset>
        );
    }
}

QtyToggle.defaultProps = {
    className: '',
    id: 'skuQty',
    min: 1,
    max: 999,
    onChange: () => {
    }
};

export default QtyToggle;